import React from "react";
import { Link } from "react-router-dom"

import { SearchBar } from "../../SearchBar/SearchBar";

import "./NavBar.css";

export const NavBar = () => {

    return(

        <div
            className="row"
            id="nav"
        >
            <div className="col-lg-4 col-md-4 col-sm-4 col-6 d-none d-sm-none d-md-flex">
                <Link to="/">
                    <div className="title-container ml-4">
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-see-monkey.png"
                            alt="img"
                            width="50"
                            height="50"
                            draggable="false"
                        />
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-hear-monkey.png"
                            alt="img"
                            width="50"
                            height="50"
                            draggable="false"
                        />
                        <img
                            src="https://valentinnicheglod.github.io/MONO-/no-speak-monkey.png"
                            alt="img"
                            width="50"
                            height="50"
                            draggable="false"
                        />
                        <div className="d-lg-flex d-md-none d-sm-none">
                            <h2 className="title">MONO</h2>
                        </div>
                    </div>
                </Link>
            </div>
            <div className="col-lg-5 col-md-7 col-sm-10 col-10 ml-5">
                <SearchBar />
            </div>

        </div>

    );
};
